/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import getDesignCodeYearDescFromDesignCodeYear from '../getDesignCodeYearDescFromDesignCodeYear.js';

// Canonical list of selectable seismic design code years, newest first. This is
// the single source of truth shared by the model form UI (the Code Year select
// menu) and the Bedrock agent's input schema / validation, so the agent only
// ever sets a year that a user could actually pick in the form.
export const designCodeYears = [
  2022, 2016, 2010, 2005, 2002, 1997, 1994, 1991, 1988, 1985, 1982, 1979, 1976, 1973, 1967, 1964,
  1961, 1958, 1955, 1952, 1949, 1946, 1943, 1940, 1937, 1935, 1927,
];

// Human-readable description for a design code year. 2022 maps to a combined
// label because ASCE 2022 / ASCE 2016 apply to non-structural / structural.
export const getDesignCodeYearDesc = year =>
  year === 2022
    ? 'ASCE 2022/ASCE 2016 (non-struct/struct)'
    : getDesignCodeYearDescFromDesignCodeYear(year);

// { value, text } options for select menus and enumerated agent fields, in
// display order. The stored value is the integer year as a string.
export const designCodeYearOptions = designCodeYears.map(year => ({
  value: String(year),
  text: getDesignCodeYearDesc(year),
}));
